import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PATH } from 'shared';
import { clearActiveOfferId, clearProveApp, setCreditApplication, setLenderName, setLenderReferenceId, setPersonalInfo, setPrequalification, } from '../../credit_application/actions';
/**
 * This hook is used to reset the appropriate redux state and redirect the user to the appropriate page
 * when pressing the back button after submitting an application.
 * @param adsStoreNumber - The ads store number of the practice
 * @param locationId - The location id of the practice
 * @returns A boolean indicating if the user needs to be redirected based on the submittedWithProve session storage item
 */
function useResetSubmittedApp({ adsStoreNumber, locationId, }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const submittedWithProve = sessionStorage.getItem('submittedWithProve');
    const needsToReroute = useRef(!!submittedWithProve);
    const clearReduxState = () => {
        dispatch(setCreditApplication(null));
        dispatch(setPersonalInfo(undefined));
        dispatch(setPrequalification(null));
        dispatch(setLenderReferenceId(null));
        dispatch(setLenderName(null));
        dispatch(clearProveApp());
        dispatch(clearActiveOfferId());
    };
    useEffect(() => {
        if (submittedWithProve === 'true') {
            history.push({
                pathname: `${PATH.CREDIT_PORTAL}${PATH.PROVE?.BASE}`,
                search: adsStoreNumber && locationId
                    ? `store=${adsStoreNumber}&locationId=${locationId}`
                    : '',
            });
            sessionStorage.removeItem('fromProve');
            sessionStorage.removeItem('submittedWithProve');
            clearReduxState();
        }
        else if (submittedWithProve === 'false') {
            history.push({
                pathname: locationId
                    ? `${PATH.CREDIT_PORTAL}${PATH.LOCATION}${locationId}`
                    : `${PATH.CREDIT_PORTAL}${PATH.CREDIT_APPLICATION}${PATH.WIZARD}`,
            });
            sessionStorage.removeItem('submittedWithProve');
            clearReduxState();
        }
    }, [dispatch, history, adsStoreNumber, locationId]);
    return needsToReroute.current;
}
export default useResetSubmittedApp;
